import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import SampleProcessLog from '../../../types/sample-process-log/SampleProcessLog';
import Page from '../../../types/shared/Page';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class SampleProcessLogService {

    private RESOURCE: string = 'sample-process-log';

    constructor(private baseService: BaseService) {
    }

    /**
     * Fetches the sample process logs from the backend.
     *
     * @param page The page number to fetch.
     * @param size The number of elements to fetch per page.
     * @return The sample process logs.
     */
    public async getLatestSampleProcessLogs(page: number = 0, size: number = 10): Promise<Page<SampleProcessLog>> {
        let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
        return await this.baseService.get<Page<SampleProcessLog>>(this.RESOURCE, params);
    }

    /**
     * Fetches the sample process logs for a sample from the backend.
     *
     * @param sampleId The ID of the sample to fetch the process logs for.
     * @return The sample process logs
     */
    public async getSampleProcessLogs(sampleId: number): Promise<SampleProcessLog[]> {
        return await this.baseService.get<SampleProcessLog[]>(`${ this.RESOURCE }/sample/${ sampleId }`);
    }

    /**
     * Resends the mail for a sample process log.
     *
     * @param id The ID of the sample process log to resend the mail for.
     * @return The response.
     */
    public async resendMail(id: number): Promise<void> {
        await this.baseService.post(`${ this.RESOURCE }/${ id }/resend-mail`, {});
    }

    /**
     * Resends the latest mail for a sample.
     *
     * @param sampleId The ID of the sample to resend the latest mail for.
     * @return The response.
     */
    public async resendLatestMail(sampleId: number): Promise<void> {
        await this.baseService.post(`${ this.RESOURCE }/sample/${ sampleId }/resend-latest-mail`, {});
    }
}
